import * as Sentry from '@sentry/vue'
import { router } from '@inertiajs/vue3'

export function configureInertiaSentry(app, inertiaRoutingInstrumentation) {
  if (!isSentryEnabled()) {
    return
  }

  let integrations = [Sentry.replayIntegration()]
  if (inertiaRoutingInstrumentation) {
    integrations.push(
      Sentry.browserTracingIntegration({
        routingInstrumentation: inertiaRoutingInstrumentation
      })
    )
  }
  Sentry.init({
    app,
    dsn: __CONCIERGE_SENTRY_PUBLIC_DSN__,
    environment: __APP_ENV__,
    release: __APP_VERSION__,
    integrations: integrations,

    trackComponents: true,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^\/api\/alfred\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
  })
}

// Uses https://inertiajs.com/events
export function inertiaRoutingInstrumentation(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true
) {
  let activeTransaction
  let name
  if (startTransactionOnPageLoad) {
    name = route().current()
    activeTransaction = customStartTransaction({
      name,
      op: 'pageload',
      metadata: {
        source: 'route'
      }
    })
  }

  if (startTransactionOnLocationChange) {
    router.on('before', (_to, _from) => {
      if (activeTransaction) {
        activeTransaction.finish()
      }

      const newName = route().current()

      if (newName !== name) {
        activeTransaction = customStartTransaction({
          name: newName,
          op: 'navigation',
          metadata: {
            source: 'route'
          }
        })
      }
    })

    router.on('finish', () => {
      activeTransaction.setName(route().current(), 'route')
    })
  }
}

function isSentryEnabled() {
  const dsn = __CONCIERGE_SENTRY_PUBLIC_DSN__
  const isSentryConfigured = dsn && typeof dsn === 'string' && dsn.length > 0
  if (__APP_ENV__ === 'local') {
    return isSentryConfigured && __ANALYTICS_DEBUG__ === true
  }
  return isSentryConfigured
}
